<template>
  <div class="product is-gray">
    <div class="image d-flex align-items-center justify-content-center">
      <a :href="getUrl(item)">
        <img
          :src="imgUrl(item)"
          :alt="localize(item.names)"
          class="img-fluid"
          onerror="this.src = '/images/comingsoon.png';"
          width="145"
          height="145"
        />
      </a>
      <div
        class="hover-overlay d-flex align-items-center justify-content-center"
      >
        <div class="CTA d-flex align-items-center justify-content-center">
          <!--<a class="add-to-cart"><i class="fa fa-shopping-cart"></i></a>-->
          <a :href="getUrl(item)" class="visit-product active"
            ><i class="icon-search"></i>{{ $t('View') }}</a
          >
          <!--<a data-toggle="modal" data-target="#exampleModal" class="quick-view"><i class="fa fa-arrows-alt"></i></a>-->
        </div>
      </div>
    </div>
    <div class="title">
      <a :href="getUrl(item)">
        <h3 class="h6 text-uppercase no-margin-bottom">
          {{ localize(item.names) }}
        </h3>
      </a>
      <span v-if="priceClass !== 'sizes'" class="price text-muted">
        {{ $t('Starting at') }}
        <s
          v-if="
            item.minimumRetailPrice.amount !== item.minimumFinalPrice.amount
          "
          >{{ asCurrency(item.minimumRetailPrice.amount) }}
          <small v-if="currency != displayCurrency"
            ><s
              >{{ asDisplayCurrency(item.minimumRetailPrice.amount)
              }}<sup>1</sup></s
            ></small
          ></s
        >
        {{ asCurrency(item.minimumFinalPrice.amount) }}
        <small v-if="currency !== displayCurrency"
          >{{ asDisplayCurrency(item.minimumFinalPrice.amount)
          }}<sup>1</sup></small
        >
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Style } from '../common/CatalogItem';
import {
  asCurrency as asCurrencyFn,
  asDisplayCurrency as asDisplayCurrencyFn,
} from '../common/currency';
import { localize as genLocalize } from '../common/localize';

const props = defineProps<{
  item?: Style;
  currency?: string;
  culture?: string;
  blobDomain?: string;
  priceClass?: string;
  displayCurrency?: string;
  displayExchangeRate?: number;
}>();

function imgUrl(style: Style) {
  return (
    props.blobDomain +
    'static/style/' +
    style.agonswimId +
    '/' +
    style.assembly +
    '-preview.svg'
  );
}

function getUrl(style: Style) {
  if (props.priceClass === 'grab-bag') return `/grab-bag/${style.id}`;
  if (props.priceClass === 'overstock') return `/overstock/${style.id}`;
  if (props.priceClass === 'sizes') return `/sizes/${style.id}`;
  return `/styles/${style.id}/prints`;
}

function asCurrency(amount: number): string {
  return asCurrencyFn(props.currency, amount);
}

function asDisplayCurrency(amount: number): string {
  return asDisplayCurrencyFn(
    props.displayExchangeRate,
    props.displayCurrency,
    amount,
  );
}

function localize(dict: Record<string, string>) {
  return genLocalize(props.culture, dict);
}
</script>

<style scoped></style>
